import React from "react";
import NewSession from "./NewSession";
import TrainingHistory from "./TrainingHistory";

const Index = () => {
  return (
    <>
      <NewSession />
      <TrainingHistory />
    </>
  );
};

export default Index;
